import { render } from "./DoughnutSites.vue?vue&type=template&id=47ca26be"
import script from "./DoughnutSites.vue?vue&type=script&lang=js"
export * from "./DoughnutSites.vue?vue&type=script&lang=js"

import "./DoughnutSites.vue?vue&type=style&index=0&id=47ca26be&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__